import { Component, OnInit } from '@angular/core';
import { Contact } from '../../contact.model';
import { ContactMessage } from '../../contact-message.model';
import { Observable } from 'rxjs';
import { ContactService } from '../../contact.service';
import { ActivatedRoute } from '@angular/router';
import { switchMap, map, take } from 'rxjs/operators';
import { AvailableServicesService } from 'src/app/service-provider/available-services-layout/available-services.service';
import { Service } from 'src/app/service-provider/service.model';
import { AngularFireStorage } from '@angular/fire/storage';
import { ContactMessageForm } from '../../contact-message.form';
import { UIControlService } from 'src/app/shared/uicontrol.service';
import { IdentityService } from 'src/app/security/identity.service';
import { firestore } from 'firebase';
import { UserService } from 'src/app/user/user.service';

@Component({
  selector: 'app-contact-conversation',
  templateUrl: './contact-conversation.component.html',
  styleUrls: ['./contact-conversation.component.scss']
})
export class ContactConversationComponent implements OnInit {
  sending = false;
  formModel: ContactMessageForm;
  formModelLoading = true;
  contact$: Observable<Contact>;
  contactMessages$: Observable<Array<ContactMessage>>;
  serviceProvider$: Observable<Service>;
  serviceProviderUserName$: Observable<string>;
  serviceProfileURL$: Observable<string>;

  constructor(
    private contactService: ContactService,
    private route: ActivatedRoute,
    private availableServices: AvailableServicesService,
    private firestoreDb: AngularFireStorage,
    private uiService: UIControlService,
    private identityService: IdentityService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.route.params.pipe(take(1)).subscribe(routeParams => {
      this.formModel = new ContactMessageForm(
        routeParams.serviceKey,
        routeParams.clientUserKey
      );
      this.formModelLoading = false;
    });

    this.contact$ = this.route.params.pipe(
      switchMap(routeParams =>
        this.contactService.getContactByKey(
          routeParams.serviceKey,
          routeParams.clientUserKey
        )
      )
    );

    this.serviceProvider$ = this.contact$.pipe(
      switchMap(contact =>
        this.availableServices.getServiceByKey(contact.serviceKey)
      )
    );

    this.serviceProviderUserName$ = this.serviceProvider$.pipe(
      switchMap(user => this.userService.getUserDetailsByKey(user.userId)),
      map(details => `${details?.firstName} ${details?.lastName}`)
    );

    this.contactMessages$ = this.route.params.pipe(
      switchMap(routeParams =>
        this.contactService.getContactMessages(
          routeParams.serviceKey,
          routeParams.clientUserKey
        )
      )
    );

    this.serviceProfileURL$ = this.serviceProvider$.pipe(
      switchMap(serviceProvider => {
        if (!!serviceProvider.imageId) {
          return this.firestoreDb
            .ref(`service-provider-profiles/${serviceProvider.imageId}`)
            .getDownloadURL();
        } else {
          return this.firestoreDb.ref(`unknown-profile.jpg`).getDownloadURL();
        }
      })
    );
  }

  send() {
    if (this.formModel.formGroup.valid) {
      this.sending = true;
      this.identityService.userKey$
        .pipe(
          take(1),
          switchMap(senderKey =>
            this.contactService.addMessageToContact(
              this.formModel.model.serviceDocumentKey,
              this.formModel.userKey,
              senderKey,
              this.formModel.model.message,
              firestore.Timestamp.now()
            )
          )
        )
        .subscribe(
          () => {
            this.uiService.notifySuccess('Message sent');
          },
          error => {
            console.error(error);
            this.uiService.notifyFailure(
              'Something went wrong. Please try again in a few minutes'
            );
          },
          () => {
            this.formModel.resetMessage();
            this.sending = false;
          }
        );
    } else {
      this.uiService.notifyFailure('Please correct your entered message.');
    }
  }
}
